import React from 'react';
import { DrawerContext } from '../drawer/DrawerContextProvider';

export function useDrawerContext() {
    return React.useContext(DrawerContext);
}